import { useAccountUserListQuery } from '../../../../list/AccountUserList/queries/useAccountUserListQuery';
import { ACCOUNT_USER_LIST_STATUS } from '../../../../../../../constants/service/app/accountUserConstants';
import { UserStatusType } from '../../../../list/AccountUserList/types/accountUser';
import { AccountUserDetailTypeV2 } from '../../../common/types/accountUserDetail';
import { useAccountUserDetailQueryV2 } from '../../../common/hooks';
import toastMsg from '../../../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../../../constants/service/toastMsg/accountUserToastMsg';

type UseToTransferUserInfoParamsType = {
  currentUserCellPhone?: string | null;
  isActive: boolean;
  onSuccess: (result: number) => void;
  onError: (error: Error) => void;
};

type UseToTransferUserInfoReturnType = { fromTransferUserInfo?: AccountUserDetailTypeV2; reset: () => void };

export const useFromTransferUserInfo = ({
  currentUserCellPhone = null,
  isActive,
  onSuccess,
  onError,
}: UseToTransferUserInfoParamsType): UseToTransferUserInfoReturnType => {
  const { data: fromTransferUserId, remove } = useAccountUserListQuery<number, Error>(
    {
      cellPhone: currentUserCellPhone,
      status: ACCOUNT_USER_LIST_STATUS.ACTIVATE as UserStatusType,
      page: 1,
      pageSize: 100,
    },
    {
      enabled: !!currentUserCellPhone && isActive,
      onSuccess,
      onError,
      select: (result) => result?.users[0]?.id,
    },
  );

  const { data: fromTransferUserInfo } = useAccountUserDetailQueryV2<AccountUserDetailTypeV2>({
    userId: fromTransferUserId,
    options: {
      enabled: !!fromTransferUserId,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_REQUEST_SUCCESS),
      onError: (error) => toastMsg.error(error.message),
      select: (result) => result.user,
    },
  });

  return { fromTransferUserInfo, reset: remove };
};
